import React, { useContext } from 'react'
import { navigate } from 'gatsby'
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { AppContext } from '../App'
import PatientForm from './PatientForm'
import Layout from '../../components/Layout'
import Heading from '../../components/Heading'
import Button from '../../components/Button'
import closeIcon from '../../images/closeIcon-red.svg'
import addIcon from '../../images/addIcon.svg'
import { useNotifications } from '../../containers/Notifications'

import { PATIENT_ENDPOINT } from './index' //set new end_point

const initialValues = {
  pesel: null,
  firstName: null,
  lastName: null,
  dateOfBirth: null,
  gender: null,
  disability: null,
  address: {
    street: null,
    city: null,
    postcode: null,
    voivodeship: null,
  },
  school: {
    name: null,
    address: {
      street: null,
      city: null,
      postcode: null,
      voivodeship: null,
    },
    groupName: null,
  },
  groupName: null,
  guardian: {
    firstName: null,
    lastName: null,
    pesel: null,
    phone: null,
    email: null,
    guardianAddress: {
      street: null,
      city: null,
      postcode: null,
      voivodeship: null,
    },
  },
  unitId: null,
  targetDiagnosticianId: null,
}

const AddPatient = () => {
  const { unitId, userId, withAuth, hiddenSchoolSection } = useContext(
    AppContext
  )

  const { notify } = useNotifications()

  const addPatient = async (values) => {
    const payloadToSend = {
      pesel: '-',
      firstName: '-',
      lastName: '-',
      dateOfBirth: values.dateOfBirth.slice(0, -2)+"15",
      gender: values.gender,
      disability: values.disability,
      address: null,
      school: hiddenSchoolSection ? null : { ...values.school },
      groupName: values.groupName,
      guardian: null,
      unitId: unitId,
      targetDiagnosticianId: userId,
    }

    try {
      const response = await withAuth(PATIENT_ENDPOINT, {
        method: 'POST',
        payload: payloadToSend,
      })
      response && navigate('/app/patients')
      notify('Pacjent został utworzony.', 'success')
    } catch (e) {
    }
  }
  return (
    <Form
      enableReinitialize={true}
      initialValues={initialValues}
      mutators={{
        ...arrayMutators,
      }}
      onSubmit={addPatient}
    >
      {({ handleSubmit, submitting }) => (
        <Layout>
          <Heading title="Dodaj osobę" border={false}>
            <Button
              link="/app/patients"
              label="Anuluj"
              color="white"
              icon={closeIcon}
              srText="rejestrację nowej osoby"
              altTag=""
              imgAriaHidden={true}
            />
            <Button
              label="Dodaj nową osobę"
              icon={addIcon}
              marginLeft
              disabled={submitting}
              type="submit"
              onClick={handleSubmit}
              altTag=""
              imgAriaHidden={true}
            />
          </Heading>
          <PatientForm patient={initialValues} onSubmit={addPatient} editable />
        </Layout>
      )}
    </Form>
  )
}

export default AddPatient
